import { useEffect, useState } from 'react';

export type StyleMode = 'playful' | 'premium';

function read(): StyleMode {
  if (typeof document === 'undefined') return 'playful';
  return document.documentElement.dataset.styleMode === 'premium' ? 'premium' : 'playful';
}

/**
 * Tracks the active UI style mode from the `data-style-mode` attribute that
 * applyTheme writes on <html>. Observing the attribute (rather than reading
 * theme props) keeps it correct under the admin preview bridge, where the
 * previewed theme is pushed via postMessage and never reaches React state.
 */
export function useStyleMode(): StyleMode {
  const [mode, setMode] = useState<StyleMode>(read);

  useEffect(() => {
    const el = document.documentElement;
    setMode(read());
    const observer = new MutationObserver(() => setMode(read()));
    observer.observe(el, { attributes: true, attributeFilter: ['data-style-mode'] });
    return () => observer.disconnect();
  }, []);

  return mode;
}
